module.exports = __webpack_public_path__ + "static/media/1000981.2299e85d.png";